import Breadcrumbs, { type BreadcrumbItem } from '@/components/public/ui/Breadcrumbs';
import Container from '@/components/public/ui/Container';

interface PageHeroProps {
  badge?: string;
  breadcrumbs?: BreadcrumbItem[];
  title: string;
  accentWord?: string;
  subtitle?: string;
  className?: string;
}

// Light page hero. Eyebrow (gold) → Fraunces title with one optional
// italic-purple accent word → muted lead. See design-system.md §4.3.
export default function PageHero({
  badge,
  breadcrumbs,
  title,
  accentWord,
  subtitle,
  className = '',
}: PageHeroProps) {
  const renderTitle = () => {
    if (!accentWord) return title;
    const index = title.indexOf(accentWord);
    if (index === -1) return title;

    const before = title.slice(0, index);
    const after = title.slice(index + accentWord.length);

    return (
      <>
        {before}
        <em className="text-primary font-medium italic">{accentWord}</em>
        {after}
      </>
    );
  };

  return (
    <section className={`relative ${className}`}>
      <Container className="pt-12 pb-4 md:pt-16">
        {breadcrumbs && breadcrumbs.length > 0 && <Breadcrumbs items={breadcrumbs} />}
        {badge && (
          <p className="text-secondary mb-3 text-xs font-bold tracking-[0.14em] uppercase">
            {badge}
          </p>
        )}
        <h1 className="font-headline text-on-surface mb-5 text-4xl font-semibold sm:text-5xl md:text-6xl">
          {renderTitle()}
        </h1>
        {subtitle && (
          <p className="text-on-surface-light max-w-2xl text-base md:text-lg">{subtitle}</p>
        )}
      </Container>
    </section>
  );
}
